import ReactDOM from 'react-dom';
import React from 'react';
import Branding from './Branding';

const RemoteBranding = (isTransparent, enablePodRedirection, returnToCurrentServiceAfterRegistration,
  returnUrlQueryString, registrationSource, corporate, enableStickyNav, element) => {
  const container = document.createElement('div');
  container.setAttribute('id', 'emarketer-masthead-container');

  ReactDOM.render(<Branding
    isTransparent={isTransparent}
    enablePodRedirection={enablePodRedirection}
    returnToCurrentServiceAfterRegistration={returnToCurrentServiceAfterRegistration}
    returnUrlQueryString={returnUrlQueryString}
    registrationSource={registrationSource}
    corporate={corporate}
    enableStickyNav={enableStickyNav} />,
  element.parentNode.insertBefore(container, element.nextSibling));
};

const masthead = document.getElementById('emarketer-masthead');
const isTransparent = (masthead.getAttribute('data-isTransparent') && masthead.getAttribute('data-isTransparent').toLowerCase() === 'true') || false;
const enablePodRedirection = (masthead.getAttribute('data-enablePodRedirection') && masthead.getAttribute('data-enablePodRedirection').toLowerCase() === 'true') || false;
const returnToCurrentServiceAfterRegistration = (masthead.getAttribute('data-returnToCurrentServiceAfterRegistration') && masthead.getAttribute('data-returnToCurrentServiceAfterRegistration').toLowerCase() === 'true') || false;
const returnUrlQueryString = masthead.getAttribute('data-returnUrlQueryString') || '';
const registrationSource = masthead.getAttribute('data-registrationSource') || '';
const corporate = (masthead.getAttribute('data-corporate') && masthead.getAttribute('data-corporate').toLowerCase() === 'true') || false;
const enableStickyNav = (masthead.getAttribute('data-enableStickyNav') && masthead.getAttribute('data-enableStickyNav').toLowerCase() === 'true') || false;

const initialize = () => {
  RemoteBranding(isTransparent, enablePodRedirection,
    returnToCurrentServiceAfterRegistration, returnUrlQueryString, registrationSource, corporate, enableStickyNav,
    document.getElementById('emarketer-masthead'));
};

initialize();

export default RemoteBranding;
